export default "__VITE_ASSET__64211582__"